/**
 * UPLOAD WIZARD REDUX REDUCERS
 *
 * Description here.
 *
 * @version 0.1
 */

import {

    UPLOAD_INITIAL_PHASE,
    UPLOAD_FILE_SELECTED,
    UPLOAD_STARTED,
    UPLOAD_SUCCESS,
    UPLOAD_CANCELED,
    UPLOAD_FAILURE,
    UPLOAD_FAILURE_SUBSCRIPTION_EXCEEDED,
    SET_CHECK_FORMATTING_RECORDS_COUNT

} from './BatchUpload.actions';

function batchUpload(state = null, action) {

    switch (action.type) {

        case UPLOAD_INITIAL_PHASE:
        case UPLOAD_CANCELED:
            return Object.assign({}, state, { stage: 'initial', subscriptionExceeded: false });

        case UPLOAD_FILE_SELECTED:
            return Object.assign(
                {}, state, {
                    stage: 'file-selected',
                    file: action.payload
                }
            );

        case UPLOAD_STARTED:
            return Object.assign(
                {}, state, {
                    stage: 'started',
                    file: state.file
                }
            );

        case UPLOAD_SUCCESS:
            return Object.assign(
                {}, state, {
                    stage: 'success',
                    uploadId: action.payload
                }
            );

        case UPLOAD_FAILURE:
            return Object.assign(
                {}, state, {
                    stage: 'failure',
                    uploadId: action.payload
                }
            );

        case UPLOAD_FAILURE_SUBSCRIPTION_EXCEEDED:
            return Object.assign(
                {}, state, {
                    stage: 'failure',
                    subscriptionExceeded: action.payload
                }
            );

        case SET_CHECK_FORMATTING_RECORDS_COUNT:
            return Object.assign(
                {}, state, {
                    checkFormattingEntriesCount: action.payload
                }
            );

        default:
            return state;

    }

}

export default batchUpload;


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/BatchUpload.reducers.js